"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _TopicReplyCount = require("@insided/destination/uikit/TopicReplyCount");

var _TopicViewsCount = require("@insided/destination/uikit/TopicViewsCount");

var _TopicListLikeButton = _interopRequireDefault(require("./TopicListLikeButton"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _dateRelative = _interopRequireDefault(require("../../libs/translationsUtils/dateRelative"));

var _translations = require("../../libs/translationsUtils/translations");

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var TopicFooter = function TopicFooter(props) {
  var topic = props.topic,
      showUnsubscribeBtn = props.showUnsubscribeBtn,
      handleFavoriteRemoval = props.handleFavoriteRemoval,
      userId = props.userId,
      lastPost = props.lastPost,
      extraSpacing = props.extraSpacing;
  var hasCurrentUserLiked = topic.hasCurrentUserLiked,
      numberOfViews = topic.numberOfViews,
      numberOfUnreadReplies = topic.numberOfUnreadReplies,
      isUnreadPostCountEnabled = topic.isUnreadPostCountEnabled,
      numberOfReplies = topic.numberOfReplies,
      topicId = topic.id,
      topicUrl = topic.url;
  var lastPostUrl = lastPost.url,
      lastPostAuthor = lastPost.author,
      lastPostRelativeCreationDate = lastPost.relativeCreationDate,
      lastPostCreationDate = lastPost.createdAt;
  return (0, _preact.h)("div", {
    className: "topic-view_footer ".concat(extraSpacing ? 'bottom_spacing' : '')
  }, showUnsubscribeBtn && (0, _preact.h)(_Tooltip.default, {
    trigger: (0, _preact.h)("i", {
      "aria-hidden": "true",
      className: (0, _classnames.default)('icon--star-full', 'icon--auto-width', 'thread-meta-item__icon', 'thread-meta-item__text--highlight', 'qa-topic-meta-favorite-icon'),
      onClick: function onClick() {
        return handleFavoriteRemoval();
      }
    }),
    tooltipMessage: (0, _translations.t)('Forum', 'thread.unsubscribe') //eslint-disable-line
    ,
    qaClasses: "qa-title-tooltip"
  }), (0, _preact.h)(_TopicListLikeButton.default, {
    topic: topic,
    isGuest: !userId,
    hasCurrentUserLiked: hasCurrentUserLiked
  }), (0, _preact.h)("span", {
    className: (0, _classnames.default)('thread-meta-item', 'thread-meta-item--hover-highlight', 'is-hidden-S')
  }, (0, _preact.h)(_TopicViewsCount.TopicViewsCountAction, {
    href: (0, _absoluteUrlRuntime.resolveUrl)(topicUrl),
    "data-track-type": "click",
    "data-element-name": "Search result topic meta link"
  }, (0, _preact.h)(_TopicViewsCount.TopicViewsCount, {
    views: numberOfViews
  }))), (0, _preact.h)("span", {
    className: (0, _classnames.default)('thread-meta-item', 'thread-meta-item--comments', 'thread-meta-item--hover-highlight')
  }, (0, _preact.h)(_TopicReplyCount.TopicReplyCountAction, {
    "data-track-type": "click",
    "data-element-name": "Search result topic last post link",
    href: (0, _absoluteUrlRuntime.resolveUrl)(lastPostUrl)
  }, (0, _preact.h)(_TopicReplyCount.TopicReplyCount, {
    replyCount: numberOfReplies
  })), isUnreadPostCountEnabled && Boolean(numberOfUnreadReplies) && (0, _preact.h)("span", null, (0, _preact.h)("span", {
    className: "thread-meta-item__text thread-meta-bullet"
  }, (0, _preact.h)("span", {
    className: "icon--bullet icon--auto-width"
  })), (0, _preact.h)("a", {
    "data-track-type": "click",
    "data-element-name": "Search result topic first post link",
    className: "thread-meta-item__text--highlight qa-topic-meta-new",
    href: (0, _absoluteUrlRuntime.resolveUrl)("/topic/firstNewPostRedirect?topicId=".concat(topicId))
  }, (0, _preact.h)("span", {
    className: "thread-meta-item__text--highlight"
  }, (0, _preact.h)(_phrase.default, {
    p: "forumList.meta.counter.post.user.new",
    count: {
      n: numberOfUnreadReplies !== null && numberOfUnreadReplies !== void 0 ? numberOfUnreadReplies : ''
    }
  }))))), (0, _preact.h)("span", {
    className: (0, _classnames.default)('thread-meta-item', 'thread-meta-item--last-update', 'thread-meta-item--hover-highlight')
  }, (0, _preact.h)(_UserAvatar.default, {
    user: lastPostAuthor,
    extraClass: "avatar--XS thread-meta-item__icon",
    showRank: true
  }), (0, _preact.h)(_phrase.default, {
    p: "accessibility_label.last_post_creation_date",
    renderAsText: true
  }, function (accessibilityLabelLastPostDate) {
    return (0, _preact.h)(_phrase.default, {
      p: "accessibility_label.last_post_relative_creation_date",
      renderAsText: true
    }, function (accessibilityLabelLastPostRelativeDate) {
      return (0, _preact.h)("a", {
        "data-track-type": "click",
        "data-element-name": "Search result topic post date link",
        className: "qa-topic-meta-last-post-date-link",
        href: (0, _absoluteUrlRuntime.resolveUrl)(lastPostUrl),
        "aria-label": lastPostCreationDate ? accessibilityLabelLastPostDate : accessibilityLabelLastPostRelativeDate
      }, (0, _preact.h)("time", {
        className: "thread-meta-item__text",
        dateTime: lastPostCreationDate ? new Date(lastPostCreationDate).toISOString() : undefined
      }, lastPostCreationDate ? (0, _preact.h)(_dateRelative.default, {
        dateTime: lastPostCreationDate
      }) : lastPostRelativeCreationDate));
    });
  })));
};

var _default = TopicFooter;
exports.default = _default;